import { render, staticRenderFns } from "./estate-box.vue?vue&type=template&id=556f35e9&"
import script from "./estate-box.vue?vue&type=script&lang=js&"
export * from "./estate-box.vue?vue&type=script&lang=js&"
import style0 from "./estate-box.vue?vue&type=style&index=0&id=556f35e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports